import React from "react";
import "./styles.scss";

import { Backdrop } from "@mui/material";
const Loader = () => {
  return (
    <Backdrop sx={{ color: "#fff", zIndex: 1310 }} open={true}>
      <div className="loading-spinner"></div>
    </Backdrop>
  );
};

export default Loader;
